/* eslint-disable max-len */
import { Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';

export const MESSAGE_AFTER_SUCCESSFULLY_GET_SECRETS =
  'It is not possible to recall your Client Id and Client Secret, so you must download or write them down. In case of loss, you can generate new ones.';
export const AlertAfterSuccefullyGetSecrets = () => (
  <AlertBoxMsg severity="success">
    <Box>
      <Box style={{ marginBottom: '8px' }}>You successfully received your Client Id and Client Secret</Box>
      <Box>{MESSAGE_AFTER_SUCCESSFULLY_GET_SECRETS}</Box>
    </Box>
  </AlertBoxMsg>
);

export const AlertAfterSuccefullyGetSecretsInRegenerateForm = () => (
  <AlertBoxMsg severity="success">
    <Box>
      <Box style={{ marginBottom: '16px' }}>You successfully regenerated your Client Id and Client Secret.</Box>
      <Box>
        It is not possible to recall your Client Id and Client Secret, so you must <b>download</b> or write them down.
        In case of loss, you can generate new ones.
      </Box>
    </Box>
  </AlertBoxMsg>
);

export const AlertThatPreviousSecretsWillBeUnusable = () => (
  <AlertBoxMsg severity="warning">
    <Box>
      <Box style={{ marginBottom: '16px' }}>Your previous secrets will be unusable.</Box>
      <Box>New client Id and secret will be generated and previous ones cannot be used.</Box>
    </Box>
  </AlertBoxMsg>
);
